const math = Math;
export const abs = math.abs;
export const min = math.min;
export const max = math.max;
export const floor = math.floor;
export const round = math.round;
export const sqrt = math.sqrt;
export const pow = math.pow;
export const cos = math.cos;
export const asin = math.asin;
export const sin = math.sin;
export const tan = math.tan;
export const PI = math.PI;
export const quadraticRatio = 2.0 / 3;
export const EPSILON = pow(2, -52);
